/*
Type Configs

Searches through all of the schema folders, creating an array of type configs
*/
import defaultConfig from './default'
const files = require.context('./', true, /index\.js$/)

const configs = [ defaultConfig ]
files.keys().forEach(key => {
  configs.push(files(key).default)
})

export default configs

/**
 * Search through the array of Type configs for an ID match, return the appropriate config
 * If a match can't be found, return a default config.
 *
 * @param  {string} id Firestore id to match for the config
 * @return {object}    Config object for the matched type
 */
export const getTypeConfig = function getTypeConfig (id) {
  return configs.find(type => type.id === id) ||
    defaultConfig
}
